import { TemplateConfig } from '../types';

export const newLovePredictionConfig: TemplateConfig = {
  id: 'new-love-prediction',
  name: '新恋情预测',
  description: '预测新恋情的发展情况',
  cardCount: 6,
  
  fieldDefaults: {
    title: '新恋情预测',
    customerQuestion: '**新恋情预测**',
    cardInfos: [
      '近期我是否会有一段新的恋情',
      '接下来这段新恋情中的对象大概是怎样的星座和性格，需要同时补充对方的外貌和身高特征，比如肤色偏白、身高175左右、瓜子脸、穿搭风格简约得体、眼睛明亮有神',
      '在接下来这段新恋情中，我们的相处是否融洽',
      '接下来这一段新恋情会是一段比较长久持续的关系吗',
      '接下来这段新恋情中的对象会是我的灵魂伴侣吗',
      '对于接下来的这段新恋情，我期望的结果是怎样的'
    ],
    cardPlaceholders: [
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌',
      '请输入第 1 行第 4 张牌'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#ff4d4f',
    backgroundColor: '#fff1f0',
    icon: '💘'
  }
};